import { FC } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { KioskHome } from '@frontend/digital-forms-ui';

const routeApi = getRouteApi('/kiosk_/$locationId');

export const KioskHomePage: FC = () => {
  const { locationId } = routeApi.useParams();

  return <KioskHome locationId={locationId} />;
};
